import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function Proof() {
  return <section aria-labelledby="prueba" className="w-full bg-navy-deep text-white" data-id="element-172" data-mp="7qlcehxyd1vl">
      <div className="mx-auto w-full max-w-4xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-173" data-mp="7so4r8mkv73h">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:gap-12" data-id="element-174" data-mp="lo05bwnezrsb">
          <div className="shrink-0" data-id="element-175" data-mp="grsym1n72c9b">
            <TrendingUpIcon className="mb-2 h-7 w-7 text-gold sm:mb-3 sm:h-8 sm:w-8" aria-hidden="true" data-id="element-176" data-mp="3p6jqygbl7ze5" />
            <p className="font-display text-4xl font-extrabold leading-none text-gold sm:text-6xl" data-id="element-177" data-mp="3k7zzy1i4zxex">
              +40 a 60
            </p>
            <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/50 sm:mt-2 sm:text-sm" data-id="element-178" data-mp="2s09garbg43g">
              puntos en 7 días
            </p>
          </div>

          <div data-id="element-179" data-mp="36fjuku1rjnau">
            <h2 id="prueba" className="font-display text-xl font-bold sm:text-3xl" data-id="element-180" data-mp="36f0n679qohb2">
              Lo que cambia en los primeros 7 días
            </h2>
            <p className="mt-2.5 text-[1rem] leading-relaxed text-white/75 sm:mt-4 sm:text-lg" data-id="element-181" data-mp="28nz15tnp3b8p">
              Al aplicar el “Hack de Usuario Autorizado” incluido en la guía, muchas de nuestras
              lectoras ven ese salto antes incluso de que su primera carta de disputa llegue al
              buró.
            </p>
          </div>
        </div>
      </div>
    </section>;
}